import { getApiDomain, getNetworkApiDomain } from './utils';
import { HTTPClient } from '../httpClient/httpClient';
import logger from '../logger';

export interface ConfigResponse {
  domain: string;
}

export interface SdkConfig {
  apiUrl?: string;
  name?: string;
  network?: string;
  networkApiUrl?: string;
  remoteUrl?: string;
}

export interface Config {
  apiUrl: string;
  network?: string;
  networkApiUrl?: string;
}

export const getRemoteConfig = async (
  remoteUrl: string,
  network?: string,
): Promise<Config> => {
  const baseConfig = {
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
  };

  const client = new HTTPClient(remoteUrl, baseConfig);
  const response = await client.getInstance().request<ConfigResponse>({});

  const { domain } = response.data;

  const apiUrl = getApiDomain(domain, new URL(remoteUrl).protocol);
  const networkApiUrl = network
    ? getNetworkApiDomain(domain, network, new URL(remoteUrl).protocol)
    : undefined;

  return { apiUrl, network, networkApiUrl };
};

export const getConfig = async (config: SdkConfig): Promise<Config> => {
  if (config.remoteUrl) {
    const remoteConfig = await getRemoteConfig(
      config.remoteUrl,
      config.network,
    );

    return { ...remoteConfig };
  }

  if (config.apiUrl) {
    return {
      apiUrl: config.apiUrl,
      network: config.network,
      networkApiUrl: config.networkApiUrl,
    };
  }

  logger.error(
    'The configuration is invalid - field `apiUrl` or `remoteUrl` is mandatory',
  );
  throw new Error(
    'The configuration is invalid - field `apiUrl` or `remoteUrl` is mandatory',
  );
};
